import React, { useState, useEffect } from "react";

import PanelTemplate from "../../templates/Panel";
import DotStatus from "../../components/DotStatus";
import BoxTabs from "../../components/BoxTabs";
import CustomerLogotypes from "../../components/CustomerLogotypes";
import Modal from "../../components/Modal";
import InputSelect from "../../components/InputSelect";
import Input from "../../components/Input";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import InputTextarea from "../../components/InputTextarea";
import Table from "../../components/Table";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { Loading } from "../../components/Loading";
import { createOptions } from "../../helpers/selects";
import states from "../../seeds/states";
import axios from "axios";
import { toast } from "react-toastify";
import { convertPercentageToInt } from "../../helpers/conversions";
import { convertToPercentage } from "../../helpers/masks";
import { ModalDelete } from "../../components/ModalDelete";
import ModalCreateQuote from "../Quote/ModalCreateQuote";
import moment from "moment";
import origins from "../../seeds/origins";
import { canSeeBrands, canUseGestao, getData, hasPermission, hasPlanFeature } from "../../services/auth";
import ModalCreateCustomer from "../../components/ModalCreateCustomer";
import InputCheckboxUnique from "../../components/InputCheckboxUnique";
import AddressTab from "../../components/tabs/AddressTab";
import InputEditorFull from "../../components/InputEditorTiny";
import SelectBrand from "../../components/selects/SelectBrand";
import { useCnpjLookup } from "../../components/InputCnpjLookup";
import Icon from "../../components/Icon";
import usePaymentOptions from "../../components/PaymentCondition/usePaymentOptions";
import useNewPaymentTerm from "../../components/PaymentCondition/useNewPaymentTerm";
import CompanyReceitaSummary, { receitaFromCompany, receitaFromLookup } from "../../components/CompanyReceitaSummary";

const types = [
    {label: 'Fornecedor de gravação', value: 'customization'},
    {label: 'Fornecedor de produto', value: 'product'},
    {label: 'Cliente', value: 'customer'},
    {label: 'Faturamento', value: 'billing'},
    {label: 'Transportadora', value: 'shipping'}
];

const QuotesTab = ({quotes}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, [quotes]);

    const generateData = () => {
        const header = ['Código', 'Data da solicitação', 'Status'];
        const rows = [];
        
        if (quotes && Array.isArray(quotes)) {
            quotes.map(quote => {
                rows.push({
                    data: [
                        quote.code,
                        moment(quote.created_at).format('DD/MM/YYYY HH:mm'),
                        <>
                            <DotStatus color={quote.status_color} size={15} />
                            {quote.status_name}
                        </>
                    ],
                    to: `/quote/edit/${quote.id}`
                });
            });
        }

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const OrdersTab = ({orders}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, [orders]);

    const generateData = () => {
        const header = ['Código', 'Data da solicitação', 'Status'];
        const rows = [];
        
        if (orders && Array.isArray(orders)) {
            orders.map(order => {
                rows.push({
                    data: [
                        order.code,
                        moment(order.created_at).format('DD/MM/YYYY HH:mm'),
                        <>
                            <DotStatus color={order.status_color} size={15} />
                            {order.status_name}
                        </>
                    ],
                    to: `/order/edit/${order.id}`
                });
            });
        }

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const UpdatedHint = ({previous, undo}) => (
    <>
        <span className="input-hint__previous">Antes: {previous || 'vazio'}</span>
        <button type="button" className="input-hint__action" onClick={undo}>Desfazer</button>
    </>
);

const CompanyDetailsTab = ({
    admins, 
    company, 
    type, 
    setType, 
    isDefaultBillingCompany,
    setIsDefaultBillingCompany,
    admin, 
    setAdmin,
    tradeName,
    setTradeName,
    companyName,
    setCompanyName,
    cnpj,
    setCnpj,
    lookupCnpj,
    lookingUpCnpj,
    highlight,
    openTab,
    ibgeCityCode,
    setIbgeCityCode,
    taxPercentage,
    setTaxPercentage,
    zipCode,
    setZipCode,
    street,
    setStreet,
    number,
    setNumber,
    complement,
    setComplement,
    district,
    setDistrict,
    city,
    setCity,
    state,
    setState,
    ie,
    setIe,
    im,
    setIm,
    phone,
    setPhone,
    email,
    setEmail,
    receita,
    receitaCheckedAt,
    receitaPending,
    origin,
    canViewPrice,
    setCanViewPrice,
    setOrigin,
    tinyAPIToken,
    setTinyAPIToken,
    comments,
    setComments,
    selectedBrands,
    setSelectedBrands,
    paymentTermId,
    setPaymentTermId,
    paymentMethodId,
    setPaymentMethodId
}) => {
    const { terms, methods, addTerm } = usePaymentOptions(null);
    const newTerm = useNewPaymentTerm({
        created: term => {
            addTerm(term);
            setPaymentTermId(term.id);
        },
    });

    return (
        <div>
            {newTerm.modal}
            <h2 className="section-title">Dados cadastrais</h2>
            <div className="row">
                <div className="col-2">
                    <Input type={`text`} label={`Código`} value={company.code} disabled={true} />
                </div>
                <div className="col-4">
                    <InputSelect label={`Marcadores`} options={types} value={type} change={setType} isMulti={true} />
                </div>
                {type.includes('customer') &&
                    <div className="col-3">
                        <InputSelect label={`Responsável`} options={createOptions(admins, 'name', 'id', true)} value={admin} change={setAdmin} />
                    </div>
                }
                {!type.includes('billing') &&
                    <div className="col-3">
                        <InputSelect label={`Onde nos conheceu`} options={origins} value={origin} change={setOrigin} />
                    </div>
                }
                {type.includes('billing') &&
                    <div className="col-3">
                        <div style={{ paddingTop: 18}}>
                            <InputCheckboxUnique label={`Empresa de faturamento padrão`} change={setIsDefaultBillingCompany} checked={isDefaultBillingCompany} />
                        </div>
                    </div>
                }
            </div>
            <div className="row">
                <div className="col-4">
                    <Input type={`text`} label={`CNPJ`} value={cnpj} change={setCnpj} mask={`convertToCnpj`} action={lookupCnpj} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Nome da empresa`} value={tradeName} change={setTradeName} {...highlight('tradeName')} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Razão social`} value={companyName} change={setCompanyName} {...highlight('companyName')} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <Input type={`text`} label={`IE`} value={ie} change={setIe} {...highlight('ie')} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`IM`} value={im} change={setIm} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Telefone`} value={phone} change={setPhone} mask={`convertToPhone`} {...highlight('phone')} />
                </div>
                <div className="col-3">
                    <Input type={`email`} label={`E-mail`} value={email} change={setEmail} {...highlight('email')} />
                </div>
            </div>
            {canSeeBrands() &&
                <div className="row">
                    <div className="col-4">
                        <SelectBrand isMulti={true} selectedBrand={selectedBrands} setSelectedBrand={setSelectedBrands} minSearch={3} />
                    </div>
                </div>
            }
            {type.includes('billing') &&
                <div className="row">
                    <div className="col-4">
                        <Input type={`text`} label={`Imposto`} value={taxPercentage} change={value => setTaxPercentage( convertToPercentage(value) )} />
                    </div>
                </div>
            }
            <CompanyReceitaSummary
                receita={receita}
                checkedAt={receitaCheckedAt}
                pendingSave={receitaPending}
                showEmpty={true}
                action={
                    <Button
                        type={`transparent`}
                        size={`small`}
                        svg={`search`}
                        text={`Buscar dados atualizados`}
                        action={lookupCnpj}
                        loading={lookingUpCnpj}
                        btnClass={`company-receita-summary__action`}
                    />
                }
            />

            {hasPlanFeature('price_display') && getData().price_display_option === 'only_approved_can_view' &&
                <div style={{ marginBottom: 40}}>
                    <h2 className="section-title">Exibição de preços</h2>
                    <InputCheckboxUnique
                        label={`Pode ver preços no site`}
                        checked={canViewPrice} 
                        change={setCanViewPrice} 
                    />
                </div>
            }
            {hasPlanFeature('integration_tiny') && type.includes('billing') &&
                <>
                    <h2 className="section-title">Integrações</h2>
                    <div className="row">
                        <div className="col-4">
                            <InputTextarea type={`text`} label={`Tiny API Token`} value={tinyAPIToken} change={setTinyAPIToken} />
                        </div>
                    </div>
                </>
            }

            <h2 className="section-title">Endereço cadastral</h2>
            <div className="row">
                <div className="col-3">
                    <Input type={`text`} label={`CEP`} value={zipCode} change={setZipCode} mask={`convertToCep`} {...highlight('zipCode')} />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <Input type={`text`} label={`Logradouro`} value={street} change={setStreet} {...highlight('street')} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Número`} value={number} change={setNumber} {...highlight('number')} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Complemento`} value={complement} change={setComplement} {...highlight('complement')} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <InputSelect label={`Estado`} options={states} value={state} change={setState} {...highlight('state')} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Cidade`} value={city} change={setCity} {...highlight('city')} />
                </div>
                <div className="col-2">
                    <Input type={`text`} label={`Código IBGE`} value={ibgeCityCode} change={setIbgeCityCode} {...highlight('ibgeCityCode')} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Bairro`} value={district} change={setDistrict} {...highlight('district')} />
                </div>
            </div>
            <div className="company-address-note">
                <Icon name={`card-location`} size={16} className="company-address-note__icon" />
                <span>Endereços de entrega e de cobrança têm abas próprias:</span>
                <button type="button" className="company-address-note__link" onClick={() => openTab(2)}>Endereços de entrega</button>
                <span aria-hidden="true">·</span>
                <button type="button" className="company-address-note__link" onClick={() => openTab(3)}>Endereços de cobrança</button>
            </div>

            <h2 className="section-title">Pagamento padrão</h2>
            <div className="row">
                <div className="col-3">
                    <InputSelect
                        label={`Condição de pagamento`}
                        options={[{ label: 'Nenhuma', value: null }, ...terms.map(term => ({ label: term.name, value: term.id }))]}
                        value={paymentTermId}
                        change={setPaymentTermId}
                        {...newTerm.selectProps}
                    />
                </div>
                <div className="col-3">
                    <InputSelect
                        label={`Forma de pagamento`}
                        options={[{ label: 'Nenhuma', value: null }, ...methods.map(method => ({ label: method.name, value: method.id }))]}
                        value={paymentMethodId}
                        change={setPaymentMethodId}
                    />
                </div>
                <div className="col-6">
                    <p className="company-payment-hint">
                        Vem preenchida nos orçamentos {canUseGestao() ? 'e pedidos de compra ' : ''}novos desta empresa.
                    </p>
                </div>
            </div>

            <h2 className="section-title">Observações</h2>
            <div className="row">
                <div className="col-6">
                    <InputEditorFull label={`Observações`} value={comments} change={setComments} />
                </div>
            </div>
        </div>
    );
}

const ContactsTab = ({company, getCompany, currentTab, setCurrentTab}) => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    const [customerId, setCustomerId] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    const [customerToDelete, setCustomerToDelete] = useState(null);
    const [sortOrder, setSortOrder] = useState('name_asc');

    useEffect(() => {
        if(!showEdit) clean();
    }, [showEdit]);

    useEffect(() => {
        if(!showCreate) clean();
    }, [showCreate]);

    const updateContact = () => {
        setLoading(true);
        api.put(`/customer/${customerId}`, {
            name,
            phone,
            email
        }).then(res => {
            toast.success('Pessoa atualizada com sucesso');
            // Preservar a tab ativa ao atualizar
            const activeTab = currentTab;
            getCompany();
            setCurrentTab(activeTab);
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const customerStored = customer => {
        setLoading(true);
        // Preservar a tab ativa ao atualizar
        const activeTab = currentTab;
        getCompany();
        setCurrentTab(activeTab);
        setShowEdit(false);
    }

    const editContact = customer => {
        navigate(`/customer/edit/${customer.id}`);
    }

    const clean = () => {
        setCustomerId('');
        setName('');
        setPhone('');
        setEmail('');
    }

    const sortOptions = [
        {label: 'Nome (A-Z)', value: 'name_asc'},
        {label: 'Nome (Z-A)', value: 'name_desc'},
        {label: 'E-mail (A-Z)', value: 'email_asc'},
        {label: 'E-mail (Z-A)', value: 'email_desc'},
    ];

    const sortCustomers = (customers) => {
        if (!customers || !Array.isArray(customers)) return [];
        
        const sorted = [...customers];
        switch(sortOrder) {
            case 'name_asc':
                return sorted.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            case 'name_desc':
                return sorted.sort((a, b) => (b.name || '').localeCompare(a.name || ''));
            case 'email_asc':
                return sorted.sort((a, b) => (a.email || '').localeCompare(b.email || ''));
            case 'email_desc':
                return sorted.sort((a, b) => (b.email || '').localeCompare(a.email || ''));
            default:
                return sorted;
        }
    };

    const header = ['Nome', 'E-mail', 'Telefone', 'Empresa'];
    const rows = [];
    const sortedCustomers = sortCustomers(company?.customers?.data || []);
    sortedCustomers.map(customer => {
        let companies = customer.companies?.map(company => company.trade_name).join(', ') || '';
        rows.push({
            data: [customer.name, customer.email, customer.phone, companies],
            action: () => editContact(customer)
        });
    });

    const deleteCustomer = () => {
        setLoading(true);
        api.delete(`/customer/${customerToDelete}`).then(res => {
            setCustomerToDelete(null);
            // Preservar a tab ativa ao atualizar
            const activeTab = currentTab;
            getCompany();
            setCurrentTab(activeTab);
        }).catch(error => {
            setLoading(false);
            renderError(error);
        });
    }

    return (
        <>
            
            <Modal
                title={`Editar pessoa`}
                show={showEdit}
                close={() => setShowEdit(false)}
                footer={
                    <>
                        <Button 
                            type={`secondary`} 
                            size={`small`}
                            svg={`delete`} 
                            text={`Excluir`} 
                            loading={loading} 
                            action={() => setCustomerToDelete(customerId)}
                        />
                        <Button 
                            type={`primary`}
                            size={`small`}
                            text={`Salvar alterações`}
                            svg={`save-white`}
                            action={updateContact}
                            loading={loading}
                        />
                    </>
                }
            >
                <div className="section">
                     <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Nome`} change={setName} value={name} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`email`} label={`E-mail`} change={setEmail} value={email} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Telefone`} change={setPhone} value={phone} mask={`convertToCellphone`} />
                        </div>
                    </div>                 
                </div>
            </Modal>
            <ModalCreateCustomer
                show={showCreate}
                close={() => setShowCreate(false)}
                customerStored={customerStored}
                companies={[company.id]}
                type={company.type}
            />
            <ModalDelete 
                show={customerToDelete !== null}
                action={deleteCustomer}
                close={() => setCustomerToDelete(null)}
                loading={loading}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
                {hasPermission('create_customer') &&
                    <Button type={`secondary`} size={`small`} text={`Adicionar pessoa`} svg={`plus-blue`} action={() => setShowCreate(true)} />
                }
                <div style={{ marginLeft: 'auto', width: 200 }}>
                    <InputSelect 
                        label={`Ordenar por`} 
                        options={sortOptions} 
                        value={sortOrder} 
                        change={setSortOrder} 
                    />
                </div>
            </div>
            <Table header={header} rows={rows} loading={loading} />
        </>
    );
}

export const CompanyEdit = () => {
    const { id } = useParams();
    const navigete = useNavigate();
    const location = useLocation();

    const [admins, setAdmins] = useState([]);
    const [tabs, setTabs] = useState([]);

    const [loading, setLoading] = useState(true);
    const [company, setCompany] = useState(null);
    const [tradeName, setTradeName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [cnpj, setCnpj] = useState("");

    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [ie, setIe] = useState("");
    const [im, setIm] = useState("");

    const [taxPercentage, setTaxPercentage] = useState('0,0000 %');

    const [canViewPrice, setCanViewPrice] = useState(false);

    const [zipCode, setZipCode] = useState("");
    const [street, setStreet] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [district, setDistrict] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [ibgeCityCode, setIbgeCityCode] = useState("");

    const [receita, setReceita] = useState(null);
    const [receitaCheckedAt, setReceitaCheckedAt] = useState(null);
    const [receitaPending, setReceitaPending] = useState(false);

    const [tinyAPIToken, setTinyAPIToken] = useState("");

    const [origin, setOrigin] = useState("");

    const [type, setType] = useState([]);
    const [isDefaultBillingCompany, setIsDefaultBillingCompany] = useState(false);
    const [admin, setAdmin] = useState(null);
    const [selectedBrands, setSelectedBrands] = useState([]);

    const [confirmDelete, setConfirmDelete] = useState(false);

    const [showCreateQuote, setShowCreateQuote] = useState(false);
    const [fistRender, setFistRender] = useState(false);
    const [currentTab, setCurrentTab] = useState(0);

    const [comments, setComments] = useState("");
    const [paymentTermId, setPaymentTermId] = useState(null);
    const [paymentMethodId, setPaymentMethodId] = useState(null);

    useEffect(() => {
        getAdmins();
        getCompany();
    }, []);

    useEffect(() => {
        if (fistRender) {            
            getAddress();
            setFistRender(false)
        }
    }, [zipCode]);

    const handleZipCode = (value) => {
        setFistRender(true);
        setZipCode(value);
    }

    const getCompanyListReturnUrl = () => {
        const params = new URLSearchParams(location.search);
        const returnTo = params.get('return_to');

        const allowed = ['/company/list', '/fiscal/settings'];

        return returnTo && allowed.some(prefix => returnTo.startsWith(prefix))
            ? returnTo
            : '/company/list';
    }

    const deleteCompany = () => {
        setLoading(true);

        api.delete(`/company/${id}`).then(res => {
            navigete(getCompanyListReturnUrl());
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const getAddress = () => {
        let convertedZipCode = zipCode.replace('-', '');
        
        if(convertedZipCode.length === 8){
            axios.get(`https://viacep.com.br/ws/${convertedZipCode}/json/`).then(res => {
                let address = res.data;
                setStreet(address.logradouro);
                setDistrict(address.bairro);
                setCity(address.localidade);
                setState(address.uf);
                setIbgeCityCode(address.ibge ?? '');
            })
        }
    }

    const [updatedFields, setUpdatedFields] = useState({});

    const fieldSetters = {
        companyName: setCompanyName,
        tradeName: setTradeName,
        phone: setPhone,
        ie: setIe,
        email: setEmail,
        zipCode: setZipCode,
        street: setStreet,
        number: setNumber,
        complement: setComplement,
        district: setDistrict,
        city: setCity,
        state: setState,
        ibgeCityCode: setIbgeCityCode,
    };

    const clearUpdated = field => setUpdatedFields(fields => {
        if (!(field in fields)) return fields;

        const { [field]: _, ...rest } = fields;
        return rest;
    });

    const tracked = (field, setter) => value => {
        setter(value);
        clearUpdated(field);
    }

    const undoField = field => {
        fieldSetters[field](updatedFields[field]);
        clearUpdated(field);

        // Cidade e código IBGE andam juntos: desfazer um sem o outro deixaria o código de outra cidade.
        if (field === 'city' || field === 'state') {
            setIbgeCityCode('ibgeCityCode' in updatedFields ? updatedFields.ibgeCityCode : '');
            clearUpdated('ibgeCityCode');
        }
    }

    const highlight = field => field in updatedFields
        ? { highlighted: true, hint: <UpdatedHint previous={updatedFields[field]} undo={() => undoField(field)} /> }
        : {};

    // Diferença só de caixa ou pontuação não conta: a Receita grava em outro formato, e trocar o que o usuário
    // digitou por isso só geraria destaque à toa.
    const normalize = value => (value ?? '').toString().toLowerCase().replace(/[^0-9a-zà-ÿ]/g, '');

    const fillFromCnpj = company => {
        const incoming = {
            companyName: company.nome,
            tradeName: company.fantasia || company.nome,
            phone: company.telefone,
            ie: company.ie,
            email: company.email,
            zipCode: company.cep,
            street: company.logradouro,
            number: company.numero,
            complement: company.complemento,
            district: company.bairro,
            city: company.municipio,
            state: company.uf,
            ibgeCityCode: company.municipio ? company.ibge : '',
        };
        const current = { companyName, tradeName, phone, ie, email, zipCode, street, number, complement, district, city, state, ibgeCityCode };
        const changed = {};

        Object.entries(incoming).forEach(([field, value]) => {
            if (!value || normalize(value) === normalize(current[field])) return;

            changed[field] = current[field] ?? '';
            fieldSetters[field](value);
        });

        setUpdatedFields(changed);

        setReceita(receitaFromLookup(company));
        setReceitaPending(true);

        return Object.keys(changed).length;
    }

    const { lookup: lookupCnpj, loading: lookingUpCnpj } = useCnpjLookup(cnpj, fillFromCnpj);

    // Os dados da Receita de uma busca valem para o CNPJ buscado; trocar o CNPJ volta para o que está gravado.
    const changeCnpj = value => {
        if (value === cnpj) return;

        setCnpj(value);

        if (receitaPending) {
            setReceita(receitaFromCompany(company));
            setReceitaPending(false);
            setUpdatedFields({});
        }
    }

    // O código IBGE só vale para a cidade de onde veio; cidade ou UF digitada à mão o invalida.
    const changeCity = value => {
        setCity(value);
        setIbgeCityCode('');
    }

    const changeState = value => {
        setState(value);
        setIbgeCityCode('');
    }

    const getAdmins = () => {
        api.get(`/list`).then(res => {
            setAdmins(res.data.resources);
        });
    }

    const getCompany = () => {
        setLoading(true);

        api.get(`/company/${id}`).then(res => {
            console.log(res);
            const resource = res.data.resource;

            setCompany(resource);
            setAdmin(resource.admin_id);
            setType(resource.type);
            setIsDefaultBillingCompany(resource.is_default_billing_company);
            let toTabs = [
                'Detalhes da empresa',
                'Pessoas',
                'Endereços de entrega',
                'Endereços de cobrança',
                'Orçamentos',
                'Pedidos',
                'Logotipos'
            ];

            setTabs(toTabs);

            setPhone(resource.phone);
            setEmail(resource.email ?? '');
            setIe(resource.ie);
            setIm(resource.im ?? "");
            setIbgeCityCode(resource.ibge_city_code ?? '');
            setReceita(receitaFromCompany(resource));
            setReceitaCheckedAt(resource.receita_checked_at);
            setReceitaPending(false);

            setTaxPercentage( convertToPercentage(resource.tax_percentage ? resource.tax_percentage.toString() : '0') );
            
            setCanViewPrice(resource.can_view_price);
            setOrigin(resource.origin ?? '');
            setSelectedBrands((resource.brands ?? []).map(brand => brand.id));
            setTradeName(resource.trade_name ?? '');
            setCompanyName(resource.company_name ?? '');
            setCnpj(resource.cnpj ?? '');
            setZipCode(resource.zip_code ?? '');
            setStreet(resource.street ?? '');
            setNumber(resource.number ?? '');
            setComplement(resource.complement ?? '');
            setDistrict(resource.district ?? '');
            setCity(resource.city ?? '');

            let stateUf = ''
            if (resource.state) {
                stateUf = resource.state.toUpperCase()
            }

            setState(stateUf);

            setTinyAPIToken(resource.tiny_api_token ?? '');

            setCity(resource.city ?? '');
            setComments(resource.comments ?? '');
            setPaymentTermId(resource.payment_term_id ?? null);
            setPaymentMethodId(resource.payment_method_id ?? null);

            setFistRender(false);

        }).catch(error => {
            console.log(error)
            renderError(error);
        }).then(() => setLoading(false));
    }

    const updateCompany = () => {
        setLoading(true);
        api.put(`/company/${company.id}`, {
            ie,
            im,
            phone,
            email,
            ibge_city_code: ibgeCityCode || null,
            ...(receitaPending ? {...receita, receita_checked: true} : {}),
            trade_name: tradeName,
            company_name: companyName,
            cnpj,
            type: type,
            is_default_billing_company: isDefaultBillingCompany,
            tax_percentage: convertPercentageToInt(taxPercentage),
            can_view_price: canViewPrice,
            zip_code: zipCode,
            street,
            admin_id: type.includes('customer') ? admin : null,
            number,
            district,
            city,
            state,
            complement,
            origin,
            tiny_api_token: tinyAPIToken ? tinyAPIToken.trim() : null,
            payment_term_id: paymentTermId,
            payment_method_id: paymentMethodId,
            comments,
            brands: selectedBrands
        }).then(res => {
            toast.success('Empresa atualizada com sucesso');

            // Veio de outra tela (ex.: configuração fiscal)? Devolve para lá.
            const params = new URLSearchParams(location.search);
            if (params.get('return_to')) {
                navigete(getCompanyListReturnUrl());
                return;
            }

            getCompany();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const finishCreation = () => {
        navigete(`/quote/list`);
    }

    return (
        <>
            <ModalDelete
                show={confirmDelete}
                action={deleteCompany}
                close={() => setConfirmDelete(false)}
                loading={loading}
            />
            {showCreateQuote &&
                <ModalCreateQuote
                    close={() => setShowCreateQuote(false)}
                    finishCreation={finishCreation}
                    customerCompanyId={id}
                />
            }
            <PanelTemplate id="product-edit">
                <Loading show={loading} />
                {!loading &&
                    <BoxTabs
                        titles={tabs}
                        tab={currentTab}
                        setTab={setCurrentTab}
                        contents={[
                            <CompanyDetailsTab
                                company={company}
                                type={type}
                                setType={setType}
                                isDefaultBillingCompany={isDefaultBillingCompany}
                                setIsDefaultBillingCompany={setIsDefaultBillingCompany}
                                admins={admins}
                                admin={admin}
                                setAdmin={setAdmin}
                                tradeName={tradeName}
                                setTradeName={tracked('tradeName', setTradeName)}
                                companyName={companyName}
                                setCompanyName={tracked('companyName', setCompanyName)}
                                cnpj={cnpj}
                                setCnpj={changeCnpj}
                                lookupCnpj={lookupCnpj}
                                lookingUpCnpj={lookingUpCnpj}
                                highlight={highlight}
                                openTab={setCurrentTab}
                                ibgeCityCode={ibgeCityCode}
                                setIbgeCityCode={tracked('ibgeCityCode', value => setIbgeCityCode(value.replace(/\D/g, '').slice(0, 7)))}
                                taxPercentage={taxPercentage}
                                setTaxPercentage={setTaxPercentage}
                                zipCode={zipCode}
                                setZipCode={tracked('zipCode', handleZipCode)}
                                street={street}
                                setStreet={tracked('street', setStreet)}
                                number={number}
                                setNumber={tracked('number', setNumber)}
                                complement={complement}
                                setComplement={tracked('complement', setComplement)}
                                district={district}
                                setDistrict={tracked('district', setDistrict)}
                                city={city}
                                setCity={tracked('city', changeCity)}
                                state={state}
                                setState={tracked('state', changeState)}
                                ie={ie}
                                setIe={tracked('ie', setIe)}
                                im={im}
                                setIm={setIm}
                                phone={phone}
                                setPhone={tracked('phone', setPhone)}
                                email={email}
                                setEmail={tracked('email', setEmail)}
                                receita={receita}
                                receitaCheckedAt={receitaCheckedAt}
                                receitaPending={receitaPending}
                                origin={origin}
                                setOrigin={setOrigin}
                                canViewPrice={canViewPrice}
                                setCanViewPrice={setCanViewPrice}
                                tinyAPIToken={tinyAPIToken}
                                setTinyAPIToken={setTinyAPIToken}
                                comments={comments}
                                setComments={setComments}
                                selectedBrands={selectedBrands}
                                setSelectedBrands={setSelectedBrands}
                                paymentTermId={paymentTermId}
                                setPaymentTermId={setPaymentTermId}
                                paymentMethodId={paymentMethodId}
                                setPaymentMethodId={setPaymentMethodId}
                            />,
                            <ContactsTab
                                company={company}
                                getCompany={getCompany}
                                currentTab={currentTab}
                                setCurrentTab={setCurrentTab}
                            />,
                            <AddressTab
                                type={`shipping`}
                                company={company}
                                onAddressUpdated={getCompany}
                            />,
                            <AddressTab
                                type={`billing`}
                                company={company}
                                onAddressUpdated={getCompany}
                            />,
                            <QuotesTab
                                quotes={company?.budgets || []}
                            />,
                            <OrdersTab
                                orders={company?.orders || []}
                            />,
                            // O que o comprador enviou na vitrine chega aqui
                            // pela conversão do orçamento (BDM-1130).
                            <CustomerLogotypes companyId={id} />
                        ]}
                    />
                }
                <PageFooter spaceBetween={true}>
                    <>
                        <div>
                            {hasPermission('edit_company') && company?.company_integration === null &&
                                <Button type={`primary`} size={`small`} svg={`save-white`} text={`Salvar alterações`} action={updateCompany} />
                            }
                            {hasPermission('create_budget') && company?.company_integration === null &&
                                <Button type={`secondary`} size={`small`} text={`Criar orçamento`} action={() => setShowCreateQuote(true)} />
                            }
                        </div>
                        {hasPermission('delete_company') && company?.company_integration === null &&
                            <Button type={`secondary`} size={`small`} svg={`delete-small`} text={`Excluir`} action={() => setConfirmDelete(true)} />
                        }
                    </>
                </PageFooter>
            </PanelTemplate>
        </>
    );
}

export default CompanyEdit;